import { JobStatus } from '../../../../types/backend/jobStatus';
import { ReactElement } from 'react';
import {
  BlockOutlinedIcon,
  CalendarOutlinedIcon,
  CheckmarkCircleFilledIcon,
  CheckmarkCircleOutlinedIcon,
  HelpSquareOutlinedIcon,
  CloseCircleFilledIcon
} from '@getgo/chameleon-icons/react';
import styles from './StatusIcon.module.scss';
import Spinner from '../../../../../core/components/spinner/Spinner';

const jobStatusIconMap: Record<JobStatus, ReactElement> = {
  [JobStatus.None]: <HelpSquareOutlinedIcon size={'24px'} color={'var(--goto-icon-color-secondary)'} />,
  [JobStatus.Scheduled]: <CalendarOutlinedIcon size={'24px'} color={'var(--goto-icon-color-secondary)'} />,
  [JobStatus.Running]: <Spinner useGotoColor={true} />,
  [JobStatus.Successful]: <CheckmarkCircleFilledIcon size={'24px'} color={'var(--goto-icon-color-success)'} />,
  [JobStatus.PartiallySuccessful]: (
    <CheckmarkCircleOutlinedIcon size={'24px'} color={'var(--goto-icon-color-warning)'} />
  ),
  [JobStatus.Failed]: <CloseCircleFilledIcon size={'24px'} color={'var(--goto-icon-color-danger)'} />,
  [JobStatus.Cancelled]: <BlockOutlinedIcon size={'24px'} color={'var(--goto-icon-color-disabled)'} />
};

interface StatusIconProps {
  jobStatus?: JobStatus;
}

function StatusIcon({ jobStatus }: StatusIconProps): ReactElement {
  return (
    <div className={styles.container}>{jobStatus ? jobStatusIconMap[jobStatus] : jobStatusIconMap[JobStatus.None]}</div>
  );
}

export default StatusIcon;
